import * as yup from 'yup';

const faqsValidationSchema = yup.object().shape({
  title: yup.string().required('Question is Required'),
  description: yup.string().required('Answer is Required'),
});

export default faqsValidationSchema;
